module.exports = __webpack_public_path__ + "img/Nav_check old.a0f0ac37.svg";